import { render, staticRenderFns } from "./HotAct.vue?vue&type=template&id=b163e412&"
import script from "./HotAct.vue?vue&type=script&lang=js&"
export * from "./HotAct.vue?vue&type=script&lang=js&"
import style0 from "./HotAct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports